// Add a new entry here whenever there is a new offer/announcement to run.
// Shown as a slim banner at the top of the home page, and listed in full
// on the /offers page, automatically while today's date falls between
// validFrom and validTo (inclusive). Offers past validTo stay listed on
// /offers under "Past offers" for SEO/content history, but drop off the
// home page banner and out of the "active" list.
// Set accentStripe: true only for occasion-themed offers (festivals, etc.)
// to show the tricolor edge — leave it off for regular/generic offers.
export const OFFERS_DATA = [
  {
    id: "independence-day-2026",
    emoji: "🇮🇳",
    title: "Independence Day Special IT Offers",
    message:
      "Independence Day Offer — Free 1-year warranty, 20% off RAM & SSDs, and a free IT consultation.",
    description:
      "Powering a stronger digital India — upgrade your IT setup this Independence Day with quality products at great prices.",
    highlights: [
      "1-year warranty free on almost all IT items",
      "20% off on RAM & SSDs",
      "Free IT consultation for all your technology needs",
    ],
    validFrom: "2026-08-12",
    validTo: "2026-08-31",
    ctaText: "Get in touch",
    ctaLink: "/contact",
    accentStripe: true,
  },
];
